import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function OrderReceiverLayout() {
  const { user, canAccessPage } = useAuth();
  const navigate = useNavigate();

  const canAccess =
    user &&
    (canAccessPage('order-receiver') ||
      canAccessPage('order-receiver/dashboard') ||
      canAccessPage('order-receiver/orders') ||
      canAccessPage('order-receiver/revenue'));

  useEffect(() => {
    if (!user) return;
    if (!canAccess) {
      navigate('/dashboard', { replace: true });
      return;
    }
  }, [user, canAccess, navigate]);

  if (user && !canAccess) return null;
  return <Outlet />;
}
